import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/image/beijianqu/touxiang.png'
import _imports_1 from '../../assets/image/beijianqu/gerenzhongxin.png'
import _imports_2 from '../../assets/image/beijianqu/wodedingdan.png'
import _imports_3 from '../../assets/image/beijianqu/caigouche.png'
import _imports_4 from '../../assets/image/beijianqu/daifukuan.png'
import _imports_5 from '../../assets/image/beijianqu/daishouhuo.png'
import _imports_6 from '../../assets/image/beijianqu/kaijufapiao.png'
import _imports_7 from '../../assets/image/beijianqu/foot1.png'
import _imports_8 from '../../assets/image/beijianqu/icon1.png'
import _imports_9 from '@/assets/image/beijianqu/tuandui.png'
import _imports_10 from '@/assets/image/beijianqu/shebei.png'
import _imports_11 from '@/assets/image/beijianqu/shouhou.png'
import _imports_12 from '@/assets/image/beijianqu/jiagongdingzhi.png'
import _imports_13 from '@/assets/image/beijianqu/yuantougongcheng.png'
import _imports_14 from '@/assets/image/beijianqu/pinzhifangxin.png'
import _imports_15 from '@/assets/image/beijianqu/zuidayoujia.png'
import _imports_16 from '@/assets/image/beijianqu/kucun.png'


const _withScopeId = n => (_pushScopeId("data-v-60e65146"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home-all" }
const _hoisted_3 = { class: "banner container" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "one" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "login" }
const _hoisted_8 = { class: "register" }
const _hoisted_9 = { class: "list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "个人中心", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "我的订单", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "备件采购车", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "待付款", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "待收货", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "开具发票", -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = { style: {"background-color":"#f3f5f7","overflow":"hidden","padding-bottom":"80px"} }
const _hoisted_35 = { class: "help container" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "goods container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "备件区"),
  /*#__PURE__*/_createElementVNode("p", null, "产品一览"),
  /*#__PURE__*/_createElementVNode("span", null, "Product list")
], -1))
const _hoisted_38 = { class: "goodlist container" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "name" }
const _hoisted_42 = {
  key: 0,
  class: "s-class"
}
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "goods container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "备件区"),
  /*#__PURE__*/_createElementVNode("p", null, "推荐榜"),
  /*#__PURE__*/_createElementVNode("span", null, "Recommended list")
], -1))
const _hoisted_45 = { class: "goodlists container" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: ""
  })
], -1))
const _hoisted_47 = { class: "right" }
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<div class=\"foot container\" data-v-60e65146><div class=\"blue\" data-v-60e65146></div><div class=\"title\" data-v-60e65146><img src=\"" + _imports_8 + "\" alt=\"\" data-v-60e65146><div class=\"right\" data-v-60e65146><p data-v-60e65146>专注打造源头品质</p><span data-v-60e65146>Focus on creating source quality</span></div></div><div class=\"focus\" data-v-60e65146><div class=\"focus-item\" data-v-60e65146><img src=\"" + _imports_9 + "\" class=\"img1\" alt=\"\" data-v-60e65146><p class=\"focus-item-title\" data-v-60e65146>技术团队</p><p class=\"focus-item-tips\" data-v-60e65146>加工生产行业经验丰富技术团队放心</p></div><div class=\"focus-item\" data-v-60e65146><img src=\"" + _imports_10 + "\" class=\"img1\" alt=\"\" data-v-60e65146><p class=\"focus-item-title\" data-v-60e65146>先进设备</p><p class=\"focus-item-tips\" data-v-60e65146>精选多种仪器机械设备完善</p></div><div class=\"focus-item\" data-v-60e65146><img src=\"" + _imports_11 + "\" class=\"img1\" alt=\"\" data-v-60e65146><p class=\"focus-item-title\" data-v-60e65146>贴心售后</p><p class=\"focus-item-tips\" data-v-60e65146>畅通热线耐心为您解惑</p></div></div></div><div class=\"footTitle container\" data-v-60e65146><p class=\"footTitle-title\" data-v-60e65146>我们的服务</p><div class=\"footTitle-ul\" data-v-60e65146><div class=\"footTitle-li\" data-v-60e65146><img src=\"" + _imports_12 + "\" data-v-60e65146><p class=\"li-title\" data-v-60e65146>加工定制</p></div><div class=\"footTitle-li\" data-v-60e65146><img src=\"" + _imports_13 + "\" data-v-60e65146><p class=\"li-title\" data-v-60e65146>源头工厂</p></div><div class=\"footTitle-li\" data-v-60e65146><img src=\"" + _imports_14 + "\" data-v-60e65146><p class=\"li-title\" data-v-60e65146>最大优价</p></div><div class=\"footTitle-li\" data-v-60e65146><img src=\"" + _imports_15 + "\" data-v-60e65146><p class=\"li-title\" data-v-60e65146>品质放心</p></div><div class=\"footTitle-li\" data-v-60e65146><img src=\"" + _imports_16 + "\" data-v-60e65146><p class=\"li-title\" data-v-60e65146>库存充足</p></div></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CurrentAddress = _resolveComponent("CurrentAddress")!
  const _component_parts_list = _resolveComponent("parts-list")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_home_head),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", {
                  href: "javascript:;",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.shouqiankefu && _ctx.shouqiankefu(...args)))
                }, "售前客服")
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", {
                  href: "javascript:;",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.shouhoukefu && _ctx.shouhoukefu(...args)))
                }, "售后客服")
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_router_link, {
                to: { name: 'user' },
                custom: ""
              }, {
                default: _withCtx(({ navigate }) => [
                  _createElementVNode("div", {
                    class: "list1",
                    onClick: navigate,
                    role: "link"
                  }, _hoisted_13, 8, _hoisted_10)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: { name: 'myorder' },
                custom: ""
              }, {
                default: _withCtx(({ navigate }) => [
                  _createElementVNode("div", {
                    class: "list2",
                    onClick: navigate,
                    role: "link"
                  }, _hoisted_17, 8, _hoisted_14)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: { name: 'cart', params: { type: 1 } },
                custom: ""
              }, {
                default: _withCtx(({ navigate }) => [
                  _createElementVNode("div", {
                    class: "list3",
                    onClick: navigate,
                    role: "link"
                  }, _hoisted_21, 8, _hoisted_18)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: { name: 'myorder', params: { status: 1 } },
                custom: ""
              }, {
                default: _withCtx(({ navigate }) => [
                  _createElementVNode("div", {
                    class: "list4",
                    onClick: navigate,
                    role: "link"
                  }, _hoisted_25, 8, _hoisted_22)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: { name: 'myorder', params: { status: 4 } },
                custom: ""
              }, {
                default: _withCtx(({ navigate }) => [
                  _createElementVNode("div", {
                    class: "list5",
                    onClick: navigate,
                    role: "link"
                  }, _hoisted_29, 8, _hoisted_26)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: { name: 'myaccount', params: { type: 'third', types: '2' } },
                custom: ""
              }, {
                default: _withCtx(({ navigate }) => [
                  _createElementVNode("div", {
                    class: "list6",
                    onClick: navigate,
                    role: "link"
                  }, _hoisted_33, 8, _hoisted_30)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_CurrentAddress, null, {
            address: _withCtx(() => [
              _hoisted_36,
              _createTextVNode(" > 备件区")
            ]),
            _: 1
          })
        ]),
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partsClass.data, (mclass, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["list", { 'list-t': mclass.son.length == 0 }])
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'partssearch', params: { pid: mclass.id, sid: 0 } },
                custom: ""
              }, {
                default: _withCtx(({ navigate }) => [
                  _createElementVNode("div", {
                    onClick: navigate,
                    class: "list-p",
                    role: "link",
                    style: {"text-align":"center","cursor":"pointer"}
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.getImgUrl(mclass.icon),
                      alt: "",
                      style: {"width":"148px","height":"148px"}
                    }, null, 8, _hoisted_40),
                    _createElementVNode("div", _hoisted_41, _toDisplayString(mclass.names), 1)
                  ], 8, _hoisted_39)
                ]),
                _: 2
              }, 1032, ["to"]),
              (mclass.son)
                ? (_openBlock(), _createElementBlock("p", _hoisted_42, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mclass.son, (sclass, iindex) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        to: {
                name: 'partssearch',
                params: { pid: mclass.id, sid: sclass.id },
              },
                        custom: ""
                      }, {
                        default: _withCtx(({ navigate }) => [
                          _createElementVNode("span", {
                            onClick: navigate,
                            role: "link"
                          }, _toDisplayString(sclass.names), 9, _hoisted_43)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 256))
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 256))
        ]),
        _hoisted_44,
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_parts_list, {
              goodslit: _ctx.goodsList.data,
              listwidth: 1160
            }, null, 8, ["goodslit"])
          ])
        ])
      ]),
      _hoisted_48
    ]),
    _createVNode(_component_html_footer)
  ], 64))
}